export default function NotFound() {
    return(
        <div className="text-center text-3xl text-green-500 font-extrabold my-8">
            Not Found! Please navigate to the <a href="/" className="text-blue-500">Home Screen.</a>
        </div>
    );
}